import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export interface RegeneratePageParams {
  pageId: string;
  prompt?: string;
  organizationId: string;
}

export const regeneratePage = async (params: RegeneratePageParams): Promise<void> => {
  return await tinctApi.pages.regeneratePage(params.pageId, params.prompt);
};

export const useRegeneratePage = (
  options?: Omit<
    UseMutationOptions<void, ApiError, RegeneratePageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: regeneratePage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      queryClient.invalidateQueries({ queryKey: ['organization', args[1].organizationId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
